import React from "react";

// for external links
const URL = ({ href, children }) => (<a href={href} rel="noreferrer" target="_blank">{children}</a>);
export default URL;